/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportUpdateConnectionMutationRequest, SocialExportUpdateConnectionMutationResponse, SocialExportUpdateConnectionPathParams, SocialExportUpdateConnection400, SocialExportUpdateConnection401, SocialExportUpdateConnection403, SocialExportUpdateConnection404 } from "../models/SocialExportUpdateConnection";

export function getSocialExportUpdateConnectionUrl(id: SocialExportUpdateConnectionPathParams["id"]) {
  const res = { method: 'PATCH', url: `/social-export/v1/connections/${id}` as const }
  return res
}

/**
 * @description Updates optional custom name, station assignments, and/or platform-specific settings for a connection owned by the authenticated client. Omitted fields are left unchanged. When stationIds is present, it replaces all station assignments; an empty array clears them.
 * @summary Update a connection by id
 * {@link /social-export/v1/connections/:id}
 */
export async function socialExportUpdateConnection(id: SocialExportUpdateConnectionPathParams["id"], data: SocialExportUpdateConnectionMutationRequest, config: Partial<RequestConfig<SocialExportUpdateConnectionMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<SocialExportUpdateConnectionMutationResponse, ResponseErrorConfig<SocialExportUpdateConnection400 | SocialExportUpdateConnection401 | SocialExportUpdateConnection403 | SocialExportUpdateConnection404>, SocialExportUpdateConnectionMutationRequest>({ method : "PATCH", url : getSocialExportUpdateConnectionUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}